import { SWSmallPricingCardProps } from './SWSmallPricingCard.types';
import { DropdownCard } from './CardTypes/DropdownCard';
import { SingleNoQuantity } from './CardTypes/SingleNoQuantity';
import { useEffect, useState } from 'react';
import isEnvDevelopment from '@/helpers/isEnvDevelopment';
import { TError } from '@/services/error.types';
import axios from 'axios';
import { retrieveProduct } from '@/services/product.services';
import { DxlInformation } from '@/types/Product.types';
import { ProductBundle } from '@/types/Product.types';

export const SWSmallPricingCard = ({
  product,
  customName,
  buttonAction,
  priceDescription,
  features,
  cardType = 'dropdownType',
}: SWSmallPricingCardProps) => {
  const [productBundle, setProductBundle] = useState<ProductBundle & { dxlInformation?: DxlInformation }>();

  const fetchProductBundle = async () => {
    try {
      product.dxlInformation = undefined;
      const retrievedProdutc = await retrieveProduct(product.productId);
      if (
        !axios.isAxiosError(retrievedProdutc) &&
        retrievedProdutc.status === 200 &&
        retrievedProdutc.data &&
        retrievedProdutc.data.id
      ) {
        product.dxlInformation = retrievedProdutc.data.dxlInformation;
        setProductBundle(product);
      } else {
      }
    } catch (err) {
      const error = err as TError;
      isEnvDevelopment() && console.log(error?.response?.data.error);
    }
  };

  useEffect(() => {
    fetchProductBundle();
  }, []);

  if (cardType === 'singleNoQuantityType') {
    return (
      <SingleNoQuantity
        product={product}
        customName={customName}
        buttonAction={buttonAction}
        priceDescription={priceDescription}
        features={features}
        productBundle={productBundle}
      />
    );
  } else {
    return (
      <DropdownCard
        product={product}
        customName={customName}
        buttonAction={buttonAction}
        priceDescription={priceDescription}
        productBundle={productBundle}
      />
    );
  }
};
